import { News } from "models";

export const createLinkFromNews = (news: News) => `news/${news.header} ${news.createAt.seconds}`;
